import { CellText } from "assets/js/Styles";
import React from "react";

const committeeTabColumns = () => {
  return [
    {
      name: "COMMITTEE",
      selector: (row) => row?.committee || "",
      sortable: true,
      cell: (row) => (
        <CellText>{`Committee on ${row?.committee || ""}`}</CellText>
      ),
    },
    {
      name: "POSITION",
      selector: (row) => row?.position || "",
      sortable: true,
      cell: (row) => <CellText>{row?.position || ""}</CellText>,
    },
  ];
};

export default committeeTabColumns;
